import { AxiosResponse } from "axios";
import { trimEnd } from "lodash";
import { useEffect, useMemo, useState } from "react";

import { mapPhRooms, mapStatVisualizationRooms } from "@/lib/common-utils";
import {
  FetchRoomsResponseDto,
  SysCfgCrossRoomRsDto,
  SysCfgRawDto,
  UserResponseRegularDto,
} from "@/shared/api";

export const useStatVisualizationRooms = ({
  gameGroupsResponse,
  playhubRoomsResponse,
  user,
}: {
  gameGroupsResponse?: AxiosResponse<SysCfgCrossRoomRsDto>;
  playhubRoomsResponse?: AxiosResponse<FetchRoomsResponseDto>;
  user: UserResponseRegularDto;
}) => {
  const gameGroupsData = useMemo(() => {
    if (!gameGroupsResponse?.data.configs) return {};

    return Object.entries(gameGroupsResponse.data.configs).reduce(
      (acc: Record<string, SysCfgRawDto[]>, [key, value]) => ({
        ...acc,
        [trimEnd(key, "_eco")]: value,
      }),
      {}
    );
  }, [gameGroupsResponse]);

  const playhubRoomsData = useMemo(
    () => playhubRoomsResponse?.data?.rooms ?? [],
    [playhubRoomsResponse]
  );

  const [statVisualizationRooms, setStatVisualizationRooms] = useState(
    mapStatVisualizationRooms(playhubRoomsData, gameGroupsData, user)
  );
  const [playhubRooms, setPlayhubRooms] = useState(
    mapPhRooms(playhubRoomsData, gameGroupsData, user)
  );

  useEffect(() => {
    setPlayhubRooms(mapPhRooms(playhubRoomsData ?? [], gameGroupsData, user));
    setStatVisualizationRooms(
      mapStatVisualizationRooms(playhubRoomsData, gameGroupsData, user)
    );
  }, [gameGroupsData, playhubRoomsData, user]);

  return {
    gameGroupsData,
    statVisualizationRooms,
    playhubRooms,
    setPlayhubRooms,
    setStatVisualizationRooms,
  };
};
